import { ResetTvOutlined } from '@mui/icons-material';
import { colors } from '@mui/material';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`
// ;

console.log(API_URL, "API_URL")


export const fetchTeamDetails = async (pageNo = 1, limit = 10) => {
    // console.log(data, "data>>>>>>")
    let accesToken = localStorage.getItem("accessToken")
    try {
        const response = await axios.get(`${API_URL}auth/fetch-teams`, {
            params: { pageNo, limit },
            headers: {
                Authorization: `Bearer ${accesToken}`,
            },
        });
        // console.log(response.data, "response return ")
        return response.data;
    } catch (error) {
        console.error('Error  fetching Teams:', error);
        throw error;
    }
}


export const fetchTeamDetailswoyhoutPagination = async () => {
    // console.log(data, "data>>>>>>")
    let accesToken = localStorage.getItem("accessToken")
    try {
        const response = await axios.get(`${API_URL}auth/fetch-teams-withoutPagination`, {
            headers: {
                Authorization: `Bearer ${accesToken}`,
            },
        });
        // console.log(response.data, "response return ")
        return response.data;
    } catch (error) {
        console.error('Error  fetching Teams:', error);
        throw error;
    }
}


export const fetchUserStats = async (userId) => {
    // console.log(data, "data>>>>>>")
    try {
        const response = await axios.get(`${API_URL}custom/admin-myProfileAndStats`, {
            params: { userId },

        });
        // console.log(response.data, "response return ")
        return response.data;
    } catch (error) {
        console.error('Error  fetching Teams:', error);
        throw error;
    }
}


export const addUserInTeamApi = async (data) => {
    let accesToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.post(
            `${API_URL}auth/add-User-teams`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${accesToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error adding user in team:", error);
        throw error;
    }
};



export const addUserInTeamApiBulk = async (data) => {
    let accesToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.post(
            `${API_URL}auth/bulk-add-User-teams`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${accesToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error adding user in team:", error);
        throw error;
    }
};


export const bulkUploadUsersToTeamApi = async (formData) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.post(
            `${API_URL}auth/bulk-upload-users-to-team`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error bulk uploading users to team:", error);
        throw error;
    }
};

export const bulkUploadUsersToTeam = bulkUploadUsersToTeamApi;


export const addTeam = async (data) => {
    let accesToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.post(
            `${API_URL}auth/add-teams`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${accesToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error adding use team:", error);
        throw error;
    }
};

export const editTeam = async (data) => {
    let accesToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.post(
            `${API_URL}auth/edit-teams`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${accesToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error adding use team:", error);
        throw error;
    }
};


export const deleteTeam = async (data) => {
    let accessToken = localStorage.getItem("accessToken");

    try {
        const response = await axios.delete(`${API_URL}auth/delete-teams`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            data
        });

        return response.data;
    } catch (error) {
        console.error("Error deleting team:", error);
        throw error;
    }
};


export const getUserInTeamApi = async (payload) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const response = await axios.get(
            `${API_URL}auth/get-User-teams`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: payload
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error adding users in team:", error);
        throw error;
    }
};




export const deleteUserInTeamApi = async (data) => {
    let accesToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.delete(
            `${API_URL}auth/delete-User-teams`,
            {
                headers: {
                    Authorization: `Bearer ${accesToken}`,
                },
                data
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error adding user in team:", error);
        throw error;
    }
};


export const deleteUserInTeamApiBulk = async (data) => {
    let accesToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.delete(
            `${API_URL}auth/bulk-delete-User-teams`,
            {
                headers: {
                    Authorization: `Bearer ${accesToken}`,
                },
                data
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error adding user in team:", error);
        throw error;
    }
};


export const fetchUserTournamentApi = async (data) => {
    try {
        return await axios.get(
            `${API_URL}matches/admin/matchStatsByMoves/${data.userId}`,
            {
                params: {
                    page: data.page,
                    limit: data.limit,
                    source: data.source == "All" ? undefined : data.source || undefined,
                    fromDate: data.fromDate || undefined,
                    toDate: data.toDate || undefined,
                    matchDuration: data.matchDurationFilter || undefined,
                    color: data.color || undefined,
                    result: data.result || undefined,
                },
            }
        );
    } catch (error) {
        console.error("Error fetching user matchStatsByMoves data:", error);
        throw error;
    }
};


export const fetchMoves = async (data) => {
    try {
        return await axios.get(`${API_URL}matches/matchByMoves/${data.id}`, {
            params: {
                matchId: data.matchId,
            },
        });
    } catch (error) {
        console.error("Error fetching user matchStatsByMoves data:", error);
        throw error;
    };
}


